import styled, { css } from "styled-components";

export const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const SwitchLabel = styled.label`
  position: relative;
  display: inline-block;

  ${(props) =>
        props.size === 'small' &&
        css`
      width: 42px;
      height: 22px;
    `}

  ${(props) =>
        props.size === 'medium' &&
        css`
      width: 50px;
      height: 25px;
    `}

  ${(props) =>
        props.size === 'large' &&
        css`
      width: 56px;
      height: 27px;
    `}
`;

export const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ddd;
  border-radius: 34px;
  transition: 0.4s;

  &::before {
    position: absolute;
    content: '';
    background-color: var(--theme-color-secondary);
    border-radius: 50%;
    transition: 0.4s;

    ${(props) =>
        props.size === 'small' &&
        css`
        height: 16px;
        width: 16px;
        left: 2.7px;
        bottom: 3.2px;
      `}

    ${(props) =>
        props.size === 'medium' &&
        css`
        height: 18px;
        width: 18px;
        left: 4px;
        bottom: 3.5px;
      `}

    ${(props) =>
        props.size === 'large' &&
        css`
        height: 20px;
        width: 20px;
        left: 4.2px;
        bottom: 3.7px;
      `}
  }
`;

export const Input = styled.input`
  display: none;

  &:checked + ${Slider} {
    background-color: var(--theme-color-primary);
  }

  &:checked + ${Slider}::before {
    transform: translateX(
      ${(props) =>
        props.size === 'small'
            ? '20px'
            : props.size === 'medium'
                ? '24px'
                : '28px'}
    );
  }
`;